/* Corporate attribution and accessible CTA, v3. Never submits a lead or fires a lead-conversion event. */
(function () {
  'use strict';
  if (window.TDCPSearchV3) { window.TDCPSearchV3.refresh(); return; }
  const UTM = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','utm_id'];
  const ADS = ['gclid','gbraid','wbraid','fbclid','msclkid'];
  const KEYS = UTM.concat(ADS);
  const STORE = 'tdcp_attribution_v3';
  let memory = null;
  let cleanup = function () {};
  function clean(values, allowed) {
    const result = {};
    allowed.forEach(function (key) {
      const value = values && values[key];
      if (typeof value === 'string' && value.length && value.length <= 300 && !/[\u0000-\u001f]/.test(value)) result[key] = value;
    });
    return result;
  }
  function permissions() {
    try {
      const p = window.Shopify && window.Shopify.customerPrivacy;
      return {analytics: !!(p && p.analyticsProcessingAllowed()), marketing: !!(p && p.marketingAllowed())};
    } catch (_) { return {analytics:false, marketing:false}; }
  }
  function storedRecord() {
    try {
      const r = JSON.parse(sessionStorage.getItem(STORE) || 'null');
      return r && r.version === 3 ? {version:3, first:clean(r.first,KEYS), last:clean(r.last,KEYS)} : null;
    } catch (_) { return null; }
  }
  function removeLegacy() {
    try { KEYS.forEach(function (k) { sessionStorage.removeItem('td_' + k); }); } catch (_) {}
  }
  function attribution() {
    const consent = permissions();
    if (!consent.analytics && !consent.marketing) {
      memory = null;
      try { sessionStorage.removeItem(STORE); } catch (_) {}
      removeLegacy();
      return {};
    }
    const allowed = consent.marketing ? KEYS : UTM;
    const query = new URLSearchParams(window.location.search);
    const incoming = {};
    KEYS.forEach(function (key) { if (query.has(key)) incoming[key] = query.get(key); });
    const hasIncoming = KEYS.some(function (key) { return query.has(key); });
    // A new campaign replaces the entire last-touch record. It never inherits old click IDs or keywords.
    const previous = memory || storedRecord();
    const current = clean(incoming,allowed);
    const last = hasIncoming ? current : clean(previous && previous.last,allowed);
    const first = previous && Object.keys(previous.first).length ? clean(previous.first,allowed) : last;
    memory = {version:3, first:first, last:last};
    removeLegacy();
    try { sessionStorage.setItem(STORE,JSON.stringify(memory)); } catch (_) {}
    // Memory remains usable when storage is unavailable.
    return last;
  }
  function decorate(root) {
    const values = attribution();
    const alias = root.dataset.tdFormatParam || '';
    root.querySelectorAll('a[data-td-lead]').forEach(function (link) {
      if (!link.dataset.tdBaseHref) link.dataset.tdBaseHref = link.getAttribute('href');
      try {
        const url = new URL(link.dataset.tdBaseHref,window.location.origin);
        if (url.protocol !== 'https:' || url.hostname !== 'forms.zohopublic.com.au') return;
        KEYS.forEach(function (key) { url.searchParams.delete(key); });
        Object.keys(values).forEach(function (key) { url.searchParams.set(key,values[key]); });
        // Only a merchant-verified receiving-field alias enables format prefill.
        if (/^[A-Za-z][A-Za-z0-9_]{0,79}$/.test(alias) && link.dataset.tdFormat) url.searchParams.set(alias,link.dataset.tdFormat);
        link.href = url.toString();
      } catch (_) { /* Leave the ordinary enquiry link usable. */ }
    });
  }
  function init() {
    cleanup();
    const root = document.getElementById('td-corporate-premium');
    if (!root) return;
    const hero = root.querySelector('[data-td-hero]');
    const final = root.querySelector('[data-td-final]');
    const sticky = root.querySelector('[data-td-sticky]');
    const media = window.matchMedia('(max-width:720px)');
    let pastHero = false;
    let nearFinal = false;
    let observers = [];
    function setSticky() {
      if (!sticky) return;
      let visible = media.matches && pastHero && !nearFinal;
      // Never hide the element while a keyboard user is interacting with it.
      if (!visible && sticky.contains(document.activeElement)) visible = true;
      sticky.classList.toggle('is-visible',visible);
      sticky.setAttribute('aria-hidden',String(!visible));
      sticky.toggleAttribute('inert',!visible);
      sticky.querySelectorAll('a').forEach(function (a) { a.tabIndex = visible ? 0 : -1; });
    }
    function refresh() { decorate(root); }
    function click(event) {
      const link = event.target.closest && event.target.closest('a[data-td-lead]');
      if (!link || !root.contains(link)) return;
      refresh();
      if (permissions().analytics) {
        // Intent only. Do not label a click as a successfully submitted enquiry.
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event:'tdcp_enquiry_click',cta_placement:link.dataset.tdPlacement || '',activation_format:link.dataset.tdFormat || 'not_selected',page_path:window.location.pathname});
      }
    }
    if ('IntersectionObserver' in window && hero && final && sticky) {
      const h = new IntersectionObserver(function(entries) { pastHero = entries[0].boundingClientRect.bottom <= 0; setSticky(); });
      const f = new IntersectionObserver(function(entries) { nearFinal = entries[0].isIntersecting || entries[0].boundingClientRect.bottom < 0; setSticky(); },{rootMargin:'0px 0px 100px 0px'});
      h.observe(hero);f.observe(final);observers = [h,f];
    }
    if (media.addEventListener) media.addEventListener('change',setSticky);
    if (sticky) sticky.addEventListener('focusout',setSticky);
    root.addEventListener('click',click);
    document.addEventListener('visitorConsentCollected',refresh);
    refresh();setSticky();
    cleanup = function () {
      observers.forEach(function (o) { o.disconnect(); });
      if (media.removeEventListener) media.removeEventListener('change',setSticky);
      if (sticky) sticky.removeEventListener('focusout',setSticky);
      root.removeEventListener('click',click);
      document.removeEventListener('visitorConsentCollected',refresh);
    };
    const shop = window.Shopify;
    if (shop && !shop.customerPrivacy && typeof shop.loadFeatures === 'function') {
      shop.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error) { if (!error && root.isConnected) refresh(); });
    }
  }
  window.TDCPSearchV3 = {refresh:init};
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',function(event) { if (event.target.querySelector && event.target.querySelector('#td-corporate-premium')) cleanup(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
}());
